module.exports = __webpack_public_path__ + "img/crizal-prevencia.435b600e.svg";